export const COMPANY = {
    name: "H2No Utah, LLC",
    shortName: "H2No Utah",
    tagline: "Waterwise landscaping built for general contractors.",
    region: "Wasatch Front",
    email: "sales@h2noutah.com",
    phone: "(385) 457-3514",
    address: "4325 W 1980 S, Ste C · Salt Lake City, UT 84104",
};

export const NAV_LINKS = [
    { label: "Capabilities", href: "#capabilities" },
    { label: "Projects", href: "#projects" },
    { label: "Partner", href: "#partner" },
    { label: "About", href: "#about" },
    { label: "Contact", href: "#contact" },
];

export const SERVICES = [
    {
        id: "xeriscape",
        title: "Waterwise & Xeriscape Planting",
        blurb: "Our specialty. Drought-tolerant designs that hit HOA curb-appeal standards and Utah's water-conservation requirements. We do traditional sod too — but waterwise is what wins long-term.",
        image: "https://customer-assets.emergentagent.com/job_turf-contractor-hub/artifacts/djgeud6y_IMG-1521.jpg",
        bullets: ["Native & adaptive species", "Drip irrigation systems", "Localscapes-compliant"],
    },
    {
        id: "turf",
        title: "Artificial Turf & Sod",
        blurb: "Synthetic turf for HOA front yards, amenity lawns, and pet areas — engineered for Utah's freeze-thaw cycles. Traditional sod available when the spec calls for it.",
        image: "https://images.unsplash.com/photo-1736955902418-a8be8e9dec1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxhcnRpZmljaWFsJTIwdHVyZiUyMGxhbmRzY2FwaW5nfGVufDB8fHx8MTc3OTI5ODQzNHww&ixlib=rb-4.1.0&q=85",
        bullets: ["Artificial turf systems", "Hydroseed & sod available", "Engineered base + drainage"],
    },
    {
        id: "walls",
        title: "Retaining Walls & Hardscape",
        blurb: "Engineered segmental walls, boulder walls, and paver hardscape for new-construction Utah HOA neighborhoods. Crews experienced reading civil plans and holding elevations.",
        image: "https://customer-assets.emergentagent.com/job_turf-contractor-hub/artifacts/5yfs6ziq_IMG_0231.JPG",
        bullets: ["Geogrid reinforced walls", "Paver patios & walkways", "Built to civil/structural specs"],
    },
    {
        id: "fencing",
        title: "Fencing & Site Finishes",
        blurb: "Vinyl, cedar, and ornamental steel fencing for new-construction Wasatch Front HOA neighborhoods and custom estates. Coordinated with grading, hardscapes, and landscape on a single PO.",
        image: "https://customer-assets.emergentagent.com/job_turf-contractor-hub/artifacts/5yfs6ziq_IMG_0231.JPG",
        bullets: ["Vinyl · Cedar · Steel", "HOA spec & gate hardware", "Coordinated with site GC"],
    },
];

export const VALUE_PROPS = [
    { stat: "Fully Insured", label: "$2M general liability + workers comp on file" },
    { stat: "On Schedule", label: "Two-week scheduling windows, weekly look-aheads" },
    { stat: "Single-Source", label: "Turf, hardscape, fencing, irrigation on one PO" },
    { stat: "Wasatch Front", label: "HOA, townhome, multi-family & commercial" },
];

export const PROJECTS = [
    {
        title: "Virtually Maintenance Free Front Yard — Draper",
        category: "Artificial Turf · Curated Beds",
        image: "https://customer-assets.emergentagent.com/job_turf-contractor-hub/artifacts/2n7z5deb_H2No_P1_Front_Left.jpg",
    },
    {
        title: "Waterwise Front Yard Conversion — Lehi",
        category: "Gem Lawn · Red Rock Xeriscape",
        image: "https://customer-assets.emergentagent.com/job_turf-contractor-hub/artifacts/djgeud6y_IMG-1521.jpg",
    },
    {
        title: "New-Build HOA Backyard — Herriman",
        category: "Sod · Segmental Wall · Fence",
        image: "https://customer-assets.emergentagent.com/job_turf-contractor-hub/artifacts/5yfs6ziq_IMG_0231.JPG",
    },
];

export const MEDIA = {
    hero: "https://static.prod-images.emergentagent.com/jobs/0743c30a-2ba2-451f-9fd9-e1ca731ba545/images/e968ed66a1fc4b19418651bfbb0772bff18ab0c20273a19ca00e8a3c5a84a52b.png",
    texture: "https://static.prod-images.emergentagent.com/jobs/0743c30a-2ba2-451f-9fd9-e1ca731ba545/images/f7c7806d4118b083feccb0b6a018bfe5f1bc1b1607c0d40f2803e97192f4f447.png",
    whyPartner: "https://images.unsplash.com/photo-1751054571128-30d45eccbe42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBjb250cmFjdG9yfGVufDB8fHx8MTc3OTI5ODQ1MHww&ixlib=rb-4.1.0&q=85",
};

export const PROJECT_TYPES = [
    "HOA / Community Association",
    "Multi-Family / Apartments",
    "Townhome / Production Builder",
    "Commercial / Office",
    "Civil / Site Development",
    "Other",
];
